<template>
  <div class="nc-page">
    <div class="header-log">
      <h1><span>MON</span>PERMIS.<span>FR</span></h1>
      <img src="../../../assets/images/logoMonPermis.png" alt="" />
    </div>

    <div class="nc-container">
      <div class="nc-card">
        <div class="nc-message">
          <div class="nc-message-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12.5"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          <p>
            Vous vous apprêtez à ajouter <strong>{{ $route.params.surnom }}</strong> à votre liste de moniteurs pour vos heures de conduite, êtes-vous sûr ?
            <br>
            Si oui, veuillez vous connecter, cela ajoutera directement le moniteur.
          </p>
        </div>

        <form class="nc-form" @submit.prevent="login">
          <h1>Connexion</h1>
          <input type="email" placeholder="Email" v-model="email" />
          <div class="password-wrapper">
            <input
              :type="showPassword ? 'text' : 'password'"
              placeholder="Mot de passe"
              v-model="password"
            />
            <button type="button" class="toggle-password" @click="showPassword = !showPassword">
              <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
          </div>
          <button v-if="isWorking === false" class="btn-action">
            Connexion
          </button>
          <button v-else type="button" disabled>
            <span><i class="fa fa-spinner fa-spin"></i> CONNEXION</span>
          </button>
          <b-alert variant="danger" v-if="error != ''" show>{{ error }}</b-alert>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";

export default {
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      isWorking: false,
      error: "",
    };
  },

  mounted() {
    if (this.$route.params.arrive !== "mail") {
      alert("Vous n'êtes pas autorisé à accéder à cette page");
      this.$router.push("/");
    }
  },

  methods: {
    login() {
      this.isWorking = true;
      window.api
        .post("/login_check", {
          username: this.email,
          password: this.password,
        })
        .then((response) => {
          this.error = "";
          let user = jwt_decode(response.data.token);
          this.$store.commit("setUser", user);
          this.$store.commit("setToken", response.data.token);

          window.api
            .post(
              "/eleve/" + user.id + "/choix-dispo/moniteur/" + this.$route.params.idmono,
              {},
              {
                headers: {
                  Authorization: "Bearer " + response.data.token,
                },
              },
            )
            .then(() => {
              this.isWorking = false;
              this.$router.push("/home");
            })
            .catch((error) => {
              console.log(error);
              this.isWorking = false;
            });
        })
        .catch(() => {
          this.error = "Mot de passe ou mail incorrect";
          this.isWorking = false;
        });
    },
  },
};
</script>

<style scoped>
div.nc-page {
  width: 100vw;
  min-height: 100vh;
  background-image: url("../../../assets/images/Fond_ordinateur.png");
  background-size: cover;
  background-color: #F4F6F9;
}

div.header-log {
  display: flex;
  border-bottom: 1px solid #E2E8F0;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  background-color: white;
  margin-bottom: 3rem;
}

div.header-log span {
  color: #6899f5;
}

div.header-log img {
  width: 60px;
  height: 60px;
  margin-top: 10px;
  margin-bottom: 10px;
}

h1 {
  font-weight: bold;
  margin: 0;
}

.nc-container {
  display: flex;
  justify-content: center;
  padding: 0 20px 3rem;
}

.nc-card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow:
    0 14px 28px rgba(0, 0, 0, 0.25),
    0 10px 10px rgba(0, 0, 0, 0.22);
  width: 460px;
  max-width: 100%;
  overflow: hidden;
}

.nc-message {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #eef4ff;
  border-bottom: 1px solid #dbe7fb;
  padding: 20px 24px;
}

.nc-message-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #6899f5;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nc-message p {
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: #1a1f2e;
  text-align: left;
}

.nc-form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 30px 50px 40px;
  text-align: center;
}

.password-wrapper {
  position: relative;
  width: 100%;
  margin: 8px 0;
}

.password-wrapper input {
  margin: 0;
  width: 100%;
  padding-right: 42px;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  padding: 0;
  color: #888;
  font-size: 14px;
  cursor: pointer;
  letter-spacing: 0;
  text-transform: none;
  font-weight: normal;
}

.toggle-password:hover {
  color: #6899f5;
}

input {
  background-color: #eee;
  border: none;
  padding: 12px 15px;
  margin: 8px 0;
  width: 100%;
  box-sizing: border-box;
}

button {
  border-radius: 20px;
  border: 1px solid #6899f5;
  background-color: #6899f5;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 45px;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
  margin-top: 14px;
}

button:focus {
  outline: none;
}

button.btn-action:active {
  transform: scale(0.95);
}

@media (max-width: 500px) {
  div.header-log img {
    width: 90px;
    height: 90px;
  }

  .nc-container {
    padding: 0 12px 2rem;
  }

  .nc-form {
    padding: 24px 24px 32px;
  }

  .nc-message {
    padding: 16px 18px;
  }
}
</style>
